import React from 'react';
import { oneOf } from 'prop-types';
import styles from './styles/styles.module.scss';
import reviewImage from '../../../../assets/images/shared/high-five@3x.png';
import photoUpload from '../../../../assets/images/shared/camera-success@3x.png';
import recordingUpload from '../../../../assets/images/shared/recording-success.png';
import routeUpload from '../../../../assets/images/icons/upload-route-complete-icon.svg';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const { TRAIL_FORM_SUCCESS } = StringConstantsMixin.strings;
const variants = {
  review: {
    src: reviewImage,
    heading: TRAIL_FORM_SUCCESS.THANKS_FOR_REVIEW,
    subTextFirst: TRAIL_FORM_SUCCESS.COMMUNITY_RELIES,
    subTextSecond: TRAIL_FORM_SUCCESS.KEEP_EM_COMING
  },
  photo: {
    src: photoUpload,
    heading: TRAIL_FORM_SUCCESS.PHOTOS_UPLOADED,
    subTextFirst: TRAIL_FORM_SUCCESS.YOURE_HELPING,
    subTextSecond: TRAIL_FORM_SUCCESS.KEEP_SNAPPING_SHARING
  },
  track: {
    src: recordingUpload,
    heading: TRAIL_FORM_SUCCESS.RECORDING_UPLOADED,
    subTextFirst: TRAIL_FORM_SUCCESS.FIND_NEW_ROUTES,
    subTextSecond: TRAIL_FORM_SUCCESS.KEEP_EXPLORING
  },
  route: {
    src: routeUpload,
    heading: TRAIL_FORM_SUCCESS.ROUTE_UPLOADED,
    subTextFirst: TRAIL_FORM_SUCCESS.ROUTE_ADDED,
    subTextSecond: TRAIL_FORM_SUCCESS.KEEP_CREATING
  }
};

const TrailFormSuccess = ({ variant }) => {
  const { src, heading, subTextFirst, subTextSecond } = variants[variant];

  return (
    <div className={styles.container}>
      <div>
        <img alt="highfive" src={src} className={styles.image} />
        <h3 className={styles.headingText}>{heading}</h3>
        <div className={styles.subText}>{subTextFirst}</div>
        <div className={styles.subText}>{subTextSecond}</div>
      </div>
    </div>
  );
};

TrailFormSuccess.propTypes = {
  variant: oneOf(['review', 'photo', 'track', 'route']).isRequired
};

export default TrailFormSuccess;
